module.exports = __webpack_public_path__ + "static/img/full2.68b9ff1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/full2.png
// module id = AWuo
// module chunks = 24